import req from '@sportninja/common/api/request'

/**
 * Updates a player's attendance data (jersey number and status).
 * @param gameId - The game ID
 * @param rosterId - The roster ID
 * @param playerId - The player ID
 * @param playerNumber - The player's jersey number
 * @param attendanceStatus - The attendance status code
 */
export const updatePlayerAttendanceData = async (
  gameId: string,
  rosterId: string,
  playerId: string,
  playerNumber: number,
  attendanceStatus: number
): Promise<void> => {
  await req(
    `/games/${gameId}/rosters/${rosterId}/players/${playerId}/attendance-data`,
    {
      method: 'PUT',
      body: JSON.stringify({
        player_number: playerNumber,
        attendance_status: attendanceStatus,
      }),
    }
  )
}

/**
 * Updates a player's attendance status.
 * @param gameId - The game ID
 * @param rosterId - The roster ID
 * @param playerId - The player ID
 * @param attendanceStatus - The attendance status code (null to clear)
 */
export const updatePlayerAttendanceStatus = async (
  gameId: string,
  rosterId: string,
  playerId: string,
  attendanceStatus: number | null
): Promise<void> => {
  await req(
    `/games/${gameId}/rosters/${rosterId}/players/${playerId}/attendance`,
    {
      method: 'PUT',
      body: JSON.stringify({ attendance_status: attendanceStatus }),
    }
  )
}

/**
 * Updates a player's proposed starting status.
 * @param gameId - The game ID
 * @param rosterId - The roster ID
 * @param playerId - The player ID
 * @param isProposedStarting - Whether the player is proposed as starting
 */
export const updateProposedStarting = async (
  gameId: string,
  rosterId: string,
  playerId: string,
  isProposedStarting: boolean
): Promise<void> => {
  await req(
    `/games/${gameId}/rosters/${rosterId}/players/${playerId}/attendance-data`,
    {
      method: 'PUT',
      body: JSON.stringify({
        is_proposed_starting: isProposedStarting,
      }),
    }
  )
}
